module.exports = __webpack_public_path__ + "img/thumb-joy.f51bbed0.png";